import FbButton from 'components/FbUI/FbButton'

interface LeadsEmptyStateProps {
  onSync: () => void
  isSyncing: boolean
}

export function LeadsEmptyState({ onSync, isSyncing }: LeadsEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center h-full py-12">
      <div className="text-center max-w-md">
        <h3 className="text-lg font-semibold text-fg mb-2">No leads yet</h3>
        <p className="text-sm text-fg-secondary mb-6">
          Sync your campaign contacts to EmailBison to start sending emails.
          This will create leads in EmailBison and attach them to your campaign.
        </p>
        <FbButton onClick={onSync} disabled={isSyncing} variant="primary">
          {isSyncing ? 'Syncing...' : 'Sync Contacts'}
        </FbButton>
      </div>
    </div>
  )
}
